import { render } from "./CotizadorElectronic.vue?vue&type=template&id=18230705"
import script from "./CotizadorElectronic.vue?vue&type=script&lang=js"
export * from "./CotizadorElectronic.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__